import {
  ClassificationObjectType,
  ClassificationRuleRecord,
} from '@fullstory/proto/fs/services/search-settings';
import { getIsReady } from '@fullstory/redux-util';
import { createSelector } from 'reselect';
import { RootReducerState } from '../../reducers';

const getClassificationRulesState = (state: RootReducerState) => state.classificationRules;

export const getClassificationRulesRequest = createSelector(
  [getClassificationRulesState],
  state => state?.classificationRules,
);

export const getClassificationRules = createSelector(
  [getClassificationRulesState],
  state => state?.classificationRulesData || [],
);

export const getClassificationRulesReady = createSelector(
  [getClassificationRulesRequest],
  request => getIsReady(request),
);

export const getClassificationRulesLoading = createSelector(
  [getClassificationRulesRequest],
  request => request?.loading || false,
);

export const getClassificationRuleRecordsByElementId = createSelector(
  [getClassificationRules],
  (rules: Record<string, ClassificationRuleRecord>): Map<string, ClassificationRuleRecord> => {
    const rulesByElementId = new Map<string, ClassificationRuleRecord>();
    Object.values(rules).forEach((record: ClassificationRuleRecord) => {
      const rule = record.classificationRule;
      if (
        rule?.objectId &&
        rule.classificationObjectType ===
          ClassificationObjectType.CLASSIFICATION_OBJECT_TYPE_ELEMENT
      ) {
        rulesByElementId.set(rule.objectId, record);
      }
    });
    return rulesByElementId;
  },
);

export const getClassificationRuleRecordForElement = (elementId: string) =>
  createSelector(
    [getClassificationRuleRecordsByElementId],
    rulesByElementId => rulesByElementId.get(elementId) || null,
  );

export const classificationRulesSelectors = {
  getClassificationRules,
  getClassificationRulesReady,
  getClassificationRulesLoading,
  getClassificationRuleRecordsByElementId,
  getClassificationRuleRecordForElement,
};
